function Error(props) {
    let { meta: { error = false, touched, submitFailed } } = props;
    if ((submitFailed || touched) && error) {
        return (
            <p className={`pt-1 text-red-800 error-message`}>{error}</p>
        )
    }

    return null;
}

export default Error;